import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect'
import IntersectAnimate from 'alpine-intersect-animate';
import collapse from '@alpinejs/collapse';
import axios from 'axios';
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Manipulation, Grid, EffectCreative, Virtual} from 'swiper/modules';
import { Loader } from 'google-maps';

import Plyr from 'plyr';
import 'plyr/dist/plyr.css';

import 'swiper/css/bundle';
import 'animate.css';

Swiper.use([Navigation, Pagination, Autoplay, Manipulation, Grid, EffectCreative, Virtual]);

window.Swiper = Swiper;

window.addEventListener('load', () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});

window.addEventListener('resize', () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});

function loaderInit() {
    if (document.querySelector('.home-loader')) {
        if (!sessionStorage.getItem("existingUser")) {
            sessionStorage.setItem("existingUser", true);
            document.body.style.paddingTop = "100vh";

            window.setTimeout(() => {
                document.querySelector('.home-loader').style.zIndex = '-1';

                window.setTimeout(() => {
                    document.body.style.paddingTop = "0";
                    window.setTimeout(() => {
                        document.querySelector('.home-loader').remove();
                    }, 2000);
                }, 5000);
            }, 200);
        } else {
            document.querySelector('.home-loader').remove();
        }
    }
}
if (window.innerWidth >=  1023){
    loaderInit();
}

Alpine.data('homeSlider', () => ({
    initSlider(element) {
        if(element.querySelectorAll('.swiper-slide').length > 1) {
            const swiper = new Swiper(element, {
                modules: [Autoplay],
                loop: true,
                speed: 700,
                watchOverflow: true,
                autoplay: {
                    delay: 7000,
                },
            });
        } else {
            const swiper = new Swiper(element, {
                loop: false,
                speed: 700,
                watchOverflow: true,
            });
        }
    }
}));

Alpine.data('basicSlider', () => ({
    init() {
        const swiper = new Swiper(this.$el.querySelector('.swiper'), {
            modules: [Autoplay, Pagination],
            loop: true,
            speed: 700,
            autoplay: {
                delay: 4000,
            },
            pagination : {
                enabled: true,
                el: this.$el.querySelector('.pagination')
            }
        });
    }
}));

Alpine.data('testimonialSlider', () => ({
    init() {
        const swiper = new Swiper(this.$el.querySelector('.swiper'), {
            modules: [Autoplay, Pagination],
            loop: true,
            speed: 700,
            slidesPerView: 1,
            slidesPerGroup: 1,
            autoplay: {
                delay: 4000,
            },
            pagination: {
                enabled: true,
                el: this.$el.querySelector('.pagination')
            },
            breakpoints: {
                480: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 40
                },
            }
        });
    }
}));

Alpine.data('logoSlider', () => ({
    initSlider(element) {
        const swiper = new Swiper(element, {
            modules: [Autoplay],
            loop: true,
            speed: 5000,
            effect: 'slide',
            watchOverflow: true,
            slidesPerView: 2,
            spaceBetween: 20,
            autoplay: {
                delay: 1,
                disableOnInteraction: false
            },
            breakpoints: {
                480: {
                    slidesPerView: 3.5,
                    centeredSlides: true,
                    spaceBetween: 30
                },
            }
        });
    }
}));

Alpine.data('peopleSlider', () => ({
    init() {
        const swiper = new Swiper(this.$el.querySelector('.people-slider'), {
            slidesPerView: 5,
            // grid: {
            //     rows: 2
            // },
            autoplay: {
                delay: 1,
                // waitForTransition: false,
                disableOnInteraction: false
            },
            effect: 'slide',
            watchOverflow: true,
            speed: 5000,
            loop: true
        });
    }
}));

Alpine.data('projectsMap', () => ({
    init() {
        const mapElement = document.querySelector('#js-map');
        const pointers = document.querySelectorAll('#pointers span');
        const loader = new Loader(process.env.MIX_GOOGLE_MAPS_API_KEY);

        const mapStyle = [
            {
                "featureType": "all",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "saturation": 36
                    },
                    {
                        "color": "#120d19"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 16
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#fefefe"
                    },
                    {
                        "lightness": 17
                    },
                    {
                        "weight": 1.2
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#efefef"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f5f5f5"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#dedede"
                    },
                    {
                        "lightness": 21
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#7a7a7a"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    },
                    {
                        "lightness": 29
                    },
                    {
                        "weight": 0.2
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#7a7a7a"
                    },
                    {
                        "lightness": 25
                    }
                ]
            },
            {
                "featureType": "road.local",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#7a7a7a"
                    },
                    {
                        "lightness": 70
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    },
                    {
                        "lightness": 19
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#353535"
                    }
                ]
            }
        ];

        loader.load().then(function (google) {
            let bounds = new google.maps.LatLngBounds();

            const map = new google.maps.Map(mapElement, {
                styles: mapStyle,
            });

            pointers.forEach((pointer) => {

                const color = pointer.getAttribute('data-color');
                const projectName = pointer.getAttribute('data-name');
                const projectDesc = pointer.getAttribute('data-desc');

                const contentString =
                    '<div class="marker-toolbox">' +
                    '<div id="siteNotice">' +
                    "</div>" +
                    '<h1 class="text-[20px] leading-[25px] mb-[20px] font-normal">' + projectName + '</h1>' +
                    '<div class="text-[16px]">' +
                    "<p>" + projectDesc + "</p>" +
                    "</div>" +
                    "</div>";

                const infowindow = new google.maps.InfoWindow({
                    content: contentString,
                    maxWidth: 500,
                });

                const svgMarker = {
                    path: "M168.3 499.2C116.1 435 0 279.4 0 192C0 85.96 85.96 0 192 0C298 0 384 85.96 384 192C384 279.4 267 435 215.7 499.2C203.4 514.5 180.6 514.5 168.3 499.2H168.3zM192 256C227.3 256 256 227.3 256 192C256 156.7 227.3 128 192 128C156.7 128 128 156.7 128 192C128 227.3 156.7 256 192 256z",
                    fillColor: color,
                    fillOpacity: 1,
                    strokeWeight: 0,
                    rotation: 0,
                    scale: 0.1,
                    anchor: new google.maps.Point(384 / 2, 512),
                };
                const myLatlng = new google.maps.LatLng(pointer.getAttribute('data-lat'), pointer.getAttribute('data-lng'));
                const marker = new google.maps.Marker({
                    position: myLatlng,
                    icon: svgMarker,
                    map,
                    title: "Hello World!",
                });

                marker.addListener("click", () => {
                    infowindow.open({
                        anchor: marker,
                        map,
                        shouldFocus: true,
                    });
                });

                bounds.extend(marker.position);
            });

            map.fitBounds(bounds);
        });
    }
}));

Alpine.data('contactForm', () => ({
    errorFields: {},
    error: '',
    submitting: false,
    success: false,

    init() {
        const form = this.$el.querySelector('form');

        form.addEventListener('submit', (e) => {
            e.preventDefault();

            this.submitting = true;
            this.error = false;
            this.errorFields = {};

            axios.post(form.action, new FormData(form))
            .then(response => {
                let parser = new DOMParser();
                const doc = parser.parseFromString(response.data, 'text/html');

                if (doc.querySelector('.js-contact-inline-error')) {
                    this.errors = true;

                    const inlineErrors = doc.querySelectorAll('.js-contact-inline-error');

                    inlineErrors.forEach((error) => {

                        const fieldHandle = error.getAttribute('data-handle')

                        this.errorFields[fieldHandle] = error.innerHTML;
                    });

                } else {

                    if (doc.querySelector('.js-contact-errors')) {
                        this.error = doc.querySelector('.js-contact-errors span').innerHTML;
                    } else {
                        this.success = true;
                    }
                }

                this.submitting = false;
            })
            .catch((error) => {
                // handle error
                this.error = 'There has been an error submitting your enquiry.';
                console.log(error);

                this.submitting = false;
            })
        })

    }
}));

Alpine.data('applicationForm', () => ({
    errorFields: {},
    error: '',
    errorText: '',
    submitting: false,
    success: false,

    init() {
        const form = this.$el.querySelector('form');

        form.addEventListener('submit', (e) => {
            e.preventDefault();

            this.submitting = true;
            this.error = false;
            this.errorFields = {};

            axios.post(form.action, new FormData(form))
                .then(response => {
                    let parser = new DOMParser();
                    const doc = parser.parseFromString(response.data, 'text/html');

                    if (doc.querySelector('.js-application-inline-error')) {
                        this.errors = true;

                        const inlineErrors = doc.querySelectorAll('.js-application-inline-error');

                        inlineErrors.forEach((error) => {

                            const fieldHandle = error.getAttribute('data-handle')

                            this.errorFields[fieldHandle] = error.innerHTML;
                        });

                    } else {

                        if (doc.querySelector('.js-application-errors')) {
                            this.error = doc.querySelector('.js-application-errors span').innerHTML;
                        } else {
                            this.success = true;
                        }
                    }

                    this.submitting = false;
                })
                .catch((error) => {
                    // handle error
                    this.error = 'There has been an error submitting your enquiry.';
                    console.log(error);

                    this.submitting = false;
                })
        })

    }
}));

Alpine.data('standardVideo', () => ({
    videoPlayer: null,
    showSplash: true,

    init() {
        if (this.$refs.video) {
            this.videoPlayer = new Plyr(this.$refs.video, {
                muted: false,
                controls: [
                    'play',
                    'progress',
                    'current-time',
                    'mute',
                    'fullscreen'
                ]
            });
        }
    },

    play() {
        this.showSplash = false;
        this.videoPlayer.play();
    }
}));



Alpine.plugin(intersect);
Alpine.plugin(IntersectAnimate);
Alpine.plugin(collapse);

window.Alpine = Alpine;
Alpine.start();
